// extracted by mini-css-extract-plugin
export default {"root":"YVQEK","rootLink":"_2H6Ir","title":"_3c_tq","body":"_1jX-Z","header":"_1HQ9Z","date":"_30S1U","status":"_1yoAK","statusSuccess":"_1YIea"};